import moment from 'moment';
import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';
import {shortDate} from '../../common/constants/datesFormat';
import {TOYOTA_RUC} from '../../common/constants/dealer';

const FORM_INITIAL_STATE = {
  'loading': false,
  'loadingCheck': false,
  'loadingPolicies': false,
  'loadingPermissions': false,
  'usernameError': '',
  'policiesList': [],
  'permissionsList': [],
  'isTdeUserNew': false,
  'values': {
    'name': '',
    'username': '',
    'password': '',
    'dealer': '',
    'email': '',
    'system': 1,
    'date': moment().format(shortDate),
    'rolesList': [],
  },
};

const getUserFromDirectory = (directory, user) => {
  return directory.find(({username}) => username === user);
};

export const userForm = (state, action) => {
  return createReducer(FORM_INITIAL_STATE, {
    [ActionTypes.CHECKING_USER_INFO]: (state, action) => ({
      ...state,
      'loadingCheck': true,
    }),
    [ActionTypes.CHECKED_USER_INFO]: (state, action) => {
      const {usernameError} = action.response.data;
      return {
        ...state,
        'loadingCheck': false,
        'usernameError':
          usernameError !== null ? usernameError : state.usernameError,
      };
    },
    [ActionTypes.CHECKED_USER_INFO_FAILED]: (state) => ({
      ...state,
      'loadingCheck': false,
    }),
    [ActionTypes.FETCHING_USERS_POLICIES_LIST]: (state, action) => ({
      ...state,
      'loadingPolicies': true,
    }),
    [ActionTypes.FETCHED_USERS_POLICIES_LIST]: (state, action) => ({
      ...state,
      'loadingPolicies': false,
      'policiesList': action.response.data,
    }),
    [ActionTypes.FETCHED_USERS_POLICIES_LIST_FAILED]: (state, action) => ({
      ...state,
      'loadingPolicies': false,
      'policiesList': [],
    }),
    [ActionTypes.FETCHING_USERS_PERMISSIONS_LIST]: (state, action) => ({
      ...state,
      'loadingPermissions': true,
    }),
    [ActionTypes.FETCHED_USERS_PERMISSIONS_LIST]: (state, action) => ({
      ...state,
      'loadingPermissions': false,
      'permissionsList': action.response.data,
    }),
    [ActionTypes.FETCHED_USERS_PERMISSIONS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loadingPermissions': false,
      'permissionsList': [],
    }),
    [ActionTypes.ADDING_USER_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.ADDED_USER_REQUEST]: (state, action) => {
      const {userInfo, userDetail, userGroups} = action.response.data;
      return {
        ...state,
        'loading': false,
        'values': {
          ...state.values,
          ...userInfo,
          ...userDetail,
          'rolesList': userGroups,
          'date': userInfo?.date ? moment(userInfo?.date).format(shortDate) : 'Sin Fecha de registro',
        },
      };
    },
    [ActionTypes.ADDED_USER_REQUEST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.FETCHING_USER_REQUEST_INFO]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_USER_REQUEST_INFO]: (state, action) => {
      const {userInfo, userDetail, userGroups} = action.response.data;
      return {
        ...state,
        'loading': false,
        'values': {
          ...state.values,
          ...userInfo,
          ...userDetail,
          'rolesList': userGroups,
          'date': userInfo?.date ? moment(userInfo?.date).format(shortDate) : 'Sin Fecha de registro',
        },
      };
    },
    [ActionTypes.UPDATING_USER_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATED_USER_REQUEST]: (state, action) => {
      const {userInfo, userDetail, userGroups} = action.response.data;
      if (userInfo.status === 'D') {
        return {
          ...state,
          ...FORM_INITIAL_STATE,
        };
      }

      return {
        ...state,
        'loading': false,
        'values': {
          ...state.values,
          ...userInfo,
          ...userDetail,
          'rolesList': userGroups,
          'date': userInfo?.date ? moment(userInfo?.date).format(shortDate) : 'Sin Fecha de registro',
        },
      };
    },
    [ActionTypes.UPDATED_USER_REQUEST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.FETCHED_USER_REQUEST_INFO_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.ADDING_NEW_USER]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.ADDED_NEW_USER]: (state, action) => {
      return {
        ...state,
        'loading': false,
        'values': {
          ...state.values,
          ...action.response.data,
        },
      };
    },
    [ActionTypes.ADDED_NEW_USER_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.FETCHING_USER]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_USER]: (state, action) => {
      const {userInfo, userDetail, userGroups} = action.response.data;

      if (userInfo && userDetail) {
        return {
          ...state,
          'loading': false,
          'values': {
            ...state.values,
            ...userInfo,
            ...userDetail,
            'rolesList': userGroups,
            'date': userInfo?.date ? moment(userInfo?.date).format(shortDate) : 'Sin Fecha de registro',
          },
        };
      }

      return {
        ...state,
        'loading': false,
        'isTdeUserNew': false,
        'values': {
          ...state.values,
          ...action.response.data,
          'date': moment(action.response.data.date).format(shortDate),
        },
      };
    },
    [ActionTypes.FETCHED_USER_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATING_USER]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATED_USER]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATED_USER_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.SET_USER_FIELD_VALUE]: (state, action) => ({
      ...state,
      'values': {
        ...state.values,
        [action.payload.field]: action.payload.value,
      },
    }),
    [ActionTypes.SET_USER_TDE_NEW]: (state, action) => ({
      ...state,
      ...FORM_INITIAL_STATE,
      'isTdeUserNew': true,
      'values': {
        ...state.values,
        'status': 'A',
      },
    }),
    [ActionTypes.SET_USER_FROM_DIRECTORY]: (state, action) => {
      const {username, directory} = action.payload;
      const userInfo = getUserFromDirectory(directory, username);
      return {
        ...state,
        'values': {
          ...state.values,
          'dealer': TOYOTA_RUC.toString(),
          'dealerName': 'TOYOTA DEL ECUADOR S.A',
          ...userInfo,
        },
      };
    },
    [ActionTypes.CLEAR_USER_FORM]: (state) => ({
      ...state,
      ...FORM_INITIAL_STATE,
    }),
  })(state, action);
};
